// Open the onboarding takeover from outside the wizard — v3 `layoutStore.activeOnboard()`: the
// workspace menu's "New workspace", the old `/onboarding` address and the Shopify return.
//
// Always OPTIONAL here. Whether the run is mandatory is the gate's decision (`useOnboardingGate`):
// a user who must onboard is upgraded to `required` by the host the moment the takeover is up.

import type { OnboardingStepKey } from '../models/onboarding.types'
import { useOnboardingStore } from '../stores/onboardingStore'

export function openOnboarding(step?: OnboardingStepKey): void {
  const store = useOnboardingStore()
  if (store.open) {
    if (step) store.setStep(step)
    return
  }
  store.start(step ? { mode: 'optional', step } : { mode: 'optional' })
}
